webpackJsonp([263791100135453],{

/***/ 109:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-image.398994dc.jpg";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _jsCookie = __webpack_require__(46);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _Hero = __webpack_require__(11);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _constants = __webpack_require__(37);
	
	var _heroImage = __webpack_require__(119);
	
	var _heroImage2 = _interopRequireDefault(_heroImage);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  About.prototype.componentDidMount = function componentDidMount() {
	    _jsCookie2.default.set(_constants.PATH_PREFIX_COOKIE, '');
	  };
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'About | matt harris' }),
	      _react2.default.createElement(
	        _Hero2.default,
	        { title: 'About Me', portrait: _heroImage2.default, portraitAlt: 'Matt Harris presenting' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Hi, I\'m Matt. I\'m a design manager and product designer living in San Francisco, with nearly a decade of experience as a fiercely collaborative designer across a range of company sizes.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\'m currently passionate about using AI to improve design and engineering workflows, especially in ways that reduce friction and help teams focus on what actually matters. I\'m particularly interested in bringing AI-first experiences to users that measurably improve their lives \u2014 not just by adding new capabilities, but by making complex systems feel clearer, faster, and more humane.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'For the past four years, I\'ve led multiple design teams at Datadog, including Dashboards, Notebooks, Monitors, and most recently the Cost team, which spans Cloud Cost Management, Billing, and Metrics. Along the way, I\'ve worked on larger initiatives like creating the ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://adp.datadog.design/', target: '_blank', rel: 'noopener noreferrer' },
	            'Associate Design Program'
	          ),
	          ' and helping establish new career paths for designers.'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '/Matt Harris Resume.pdf', download: 'Matt Harris Resume.pdf', className: 'download-resume-btn' },
	          _react2.default.createElement(
	            'svg',
	            { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M12 16L12 8', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	            _react2.default.createElement('path', { d: 'M8 12L12 16L16 12', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
	            _react2.default.createElement('path', { d: 'M4 17V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V17', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })
	          ),
	          'Download Resume'
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-78923ac501e1f8e9f4cf.js